import type { JSX } from 'react'
import type { IInputProps } from '../Input'

import { TextBoxTypes } from 'atoms/TextBox'
import { Input } from '../Input'
import {
  InputBorders,
  InputFontColors,
  InputFonts,
  InputHeight,
  InputNames,
  InputPaddings,
} from '../Input.h'

export interface IProfileInputProps extends IInputProps {}

export const ProfileInput = ({
  type = 'text',
  name = InputNames.Profile,
  placeholder = '',
  placeholderColor = InputFontColors.TEXT_ICON_SECONDARY,
  label = '',
  labelFont = TextBoxTypes.Caption4,
  font = InputFonts.Body4,
  colorDefault = InputFontColors.TEXT_ICON_PRIMARY,
  required = true,
  value = '',
  min = '',
  max = '',
  maxLength = 80,
  paddings = InputPaddings.SIZE_20,
  borders = InputBorders.BORDER_10,
  inputWrapperWidth = '100%',
  height = InputHeight.SIZE_30,
  ...rest
}: IProfileInputProps): JSX.Element => (
  <Input
    type={type}
    name={name}
    placeholder={placeholder}
    placeholderColor={placeholderColor}
    label={label}
    font={font}
    colorDefault={colorDefault}
    required={required}
    value={value}
    min={min}
    max={max}
    maxLength={maxLength}
    paddings={paddings}
    borders={borders}
    labelFont={labelFont}
    height={height}
    inputWrapperWidth={inputWrapperWidth}
    {...rest}
  />
)
